module.exports = __webpack_public_path__ + "img/header-img.708ac1b0.png";